import React from 'react'
import Main from '../Cart/Main'

export const Cart = () => {
  return (
    <>
        <Main />
    </>
  )
}
